document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.querySelector('input[type="checkbox"][required]');
  const checkoutButton = document.querySelector('#checkout');

  checkoutButton.addEventListener("click", function (event) {
    if (!checkbox.checked) {
      event.preventDefault();
      alert("Veuillez accepter les conditions générales de vente pour continuer.");
    }
  });
});